import { styled } from "@mui/material/styles";
export const PageScroll = styled("div")({
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    padding: "var(--j-sp-3)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--j-sp-3)",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
        display: "none"
    }
});
export const Dock = styled("div")({
    flexShrink: 0,
    padding: "var(--j-sp-2) var(--j-sp-3) var(--j-sp-3)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--j-sp-2)",
    borderTop: "1px solid var(--j-line)",
    background: "var(--j-surface)"
});
export const CenteredSpinner = styled("div")({
    flex: 1,
    display: "grid",
    placeItems: "center",
    padding: "var(--j-sp-6)"
});
export const Screen = styled("div")({
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    "&[hidden]": {
        display: "none"
    }
});
